import { render, staticRenderFns } from "./banner_home.vue?vue&type=template&id=7daa498e&"
import script from "./banner_home.vue?vue&type=script&lang=js&"
export * from "./banner_home.vue?vue&type=script&lang=js&"
import style0 from "./banner_home.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports